import { Component, ViewChild,HostListener, OnDestroy, OnInit,Renderer2 } from "@angular/core";
import { Router, NavigationStart,UrlSerializer,ActivatedRoute} from '@angular/router';
import { QuizService } from '../../Service/Quizservice';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import{Subscription} from 'rxjs';

declare var gtag: Function;

@Component({
  selector: "home-page",
  templateUrl: "./home.page.html", styleUrls: ["../app.component.css"],
  
})
export class HomePage  {
  teachername;
  quizcount;
  Published;
  canvas: any;
  ctx: any;
  url;
  gtmId;
  subscription:Subscription;

  @ViewChild('mychart') mychart;
  constructor(public router: Router, private QuizService: QuizService, private http: HttpClient, private route: ActivatedRoute,private renderer:Renderer2) {
    
    this.getconfigkey().subscribe(data=>{
      this.url=data['url'];
     
    })
   
  }
  
  private async getConfigData(): Promise<{ gtmId: string, url: string }> {
    const data = await this.getconfigkey().toPromise();
    return {
      gtmId: data['gtmId'],
      url: data['url']
    };
  }

  public getconfigkey():any{   
         
    return this.http.get("assets/env.json");            
    }

    

  async ngOnInit() {
        this.teachername = sessionStorage.getItem('teachername');
        const configData = await this.getConfigData();
        this.gtmId = configData.gtmId;
        const script = this.renderer.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id='+this.gtmId;
        console.log(script);
        this.renderer.appendChild(document.head, script);
        
    let users;
    let roles;
  
    if (this.teachername) {
      users = this.teachername;
      roles = "Teacher";
    } else {
      users = sessionStorage.getItem('studname');
      roles = "Student";
    }
  
  
    const gTagScript = this.renderer.createElement('script');
    gTagScript.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date()); 
    gtag('config', '`+this.gtmId+`');
    `;
  
    // Append the GTM script to the head section of the document
    this.renderer.appendChild(document.head, gTagScript);

    // Now you can safely use the gtag function
    gtag('event', 'user_details', { 'UserName': users, 'UserType': roles });
   // this.renderer.appendChild(document.head, script);
    if (this.teachername == undefined) {
      this.router.navigate(['/login'])
    }
    var date = new Date();
    date.setDate(date.getDate() - 30);
    var jsonobj1 = [
      {
        "Createdby": sessionStorage.getItem("Td"),
        "ispublished": 1,
      }];
    this.QuizService.getQuizcount(jsonobj1).subscribe(data => {localStorage.setItem("Published",data["Count"]);
  this.Published=localStorage.getItem("Published");})
      
    var jsonobj = [
      {
        "Createdby": sessionStorage.getItem("Td")
      }];
    this.QuizService.getQuizcount(jsonobj).subscribe(data => 
      {localStorage.setItem('quizcount',data["Count"]);
    this.quizcount=localStorage.getItem('quizcount');})
    document.getElementById("btnGroupDrop1").innerText = this.teachername;

    sessionStorage.setItem("key",this.Published)
  }
  logout() {
    this.router.navigate(["/"]);
  }

  @HostListener('window:popstate', ['$event'])
onPopState(event) {
window.history.forward();
this.router.navigate(["/home"]);
}
}
